// Shop-floor verbs shown while the assistant works, in the spirit of a terminal spinner's
// rotating status words. Grouped loosely: metrology, machining, drivetrain, heat treatment.
export const THINKING_VERBS = [
  "Calibrating",
  "Tolerancing",
  "Aligning",
  "Truing",
  "Gauging",
  "Zeroing",
  "Machining",
  "Milling",
  "Lathing",
  "Turning",
  "Honing",
  "Chamfering",
  "Broaching",
  "Knurling",
  "Torquing",
  "Meshing",
  "Indexing",
  "Actuating",
  "Coupling",
  "Splining",
  "Annealing",
  "Tempering",
  "Quenching",
  "Forging",
  "Sintering",
  "Damping",
  "Balancing",
  "Spooling up",
  "Preloading",
  "Governing",
] as const;

export type ThinkingVerb = (typeof THINKING_VERBS)[number];

export const THINKING_VERB_INTERVAL_MS = 2500;

// Picks a verb other than the current one so every tick visibly changes.
export function nextThinkingVerb(current: ThinkingVerb | null, random: () => number = Math.random): ThinkingVerb {
  const candidates = current === null ? THINKING_VERBS : THINKING_VERBS.filter((verb) => verb !== current);
  const index = Math.min(candidates.length - 1, Math.floor(random() * candidates.length));
  return candidates[index];
}
